import React from "react";
import LoadingSpinnerImage from "../Shared/LoadingSpinnerImage.js";

const entityIcons = {
    "systematic-review": "fas fa-file-signature",
    "systematic-review-clinical": "fas fa-file-signature",
    "systematic-review-marketpms": "fas fa-file-signature",
    "systematic-review-regulatory": "fas fa-file-signature",
    "product-skus": "fas fa-box-open",
    "product-family": "fas fa-box-open",
    "countryregistration-country": "fas fa-clipboard-list",
    "countryregistration-certificate": "fas fa-clipboard-list",
    "countryregistration-operator": "fas fa-clipboard-list",
    "compliance-standards": "fas fa-balance-scale",
    "compliance-regulatorydocuments": "fas fa-balance-scale",
};

export const EntityTypeIcon = ({ entityType }) => {
    const icon = entityIcons[entityType] || "far fa-calendar-check";
    return <i className={icon} style={{ marginRight: "8px" }}></i>;
};

const isAllTasksMenuItem = (item) =>
    item && (item.EntityId == null || item.EntityId === "") && (item.EntityType == null || item.EntityType === "");

const TaskMenu = ({ menu, fullMenu, isLoading, linkedEntityType, linkedEntityId, onSelect, hideAllTasksNav = false }) => {
    const visibleMenu = hideAllTasksNav
        ? (menu || []).filter((item) => !isAllTasksMenuItem(item))
        : (menu || []);

    return (
        <div className="thin-scrollbar" style={{ flex: "0 0 20%", minWidth: 0, maxWidth: "20%", overflowX: "hidden", overflowY: "auto", padding: "0 10px", borderRight: "1px solid #f0f0f0", boxSizing: "border-box" }}>
            {isLoading ? <LoadingSpinnerImage /> : (
                <>
                    {fullMenu && fullMenu.EntityType != null ? (
                        !hideAllTasksNav ? (
                            <div
                                className="menu-item-row"
                                style={{ cursor: "pointer", padding: "6px 10px", border: "1px solid silver", borderRadius: "15px", color: "#203864" }}
                                onClick={() => onSelect(null, null, "All Tasks")}
                            >
                                <b><i className="fas fa-arrow-left"></i> Go Back to All Tasks</b>
                            </div>
                        ) : null
                    ) : <div><b>Task Manager Menu</b></div>}

                    {fullMenu && fullMenu.EntityType != null && (
                        <div
                            className="menu-item-row"
                            style={{ cursor: "pointer", display: "flex", padding: "6px", marginTop: "12px", color: (linkedEntityId == null || linkedEntityId === "") ? "#0052cc" : "#203864", backgroundColor: (linkedEntityId == null || linkedEntityId === "") ? "#f1f1f1" : "transparent" }}
                            onClick={() => onSelect(fullMenu.EntityType, fullMenu.EntityId, fullMenu.Title)}
                        >
                            <div style={{ flex: 1, fontWeight: "bold" }}><EntityTypeIcon entityType={fullMenu.EntityType} />{fullMenu.Title}</div>
                            <span style={{ fontSize: "9pt", borderRadius: "15px", backgroundColor: "#f0f0f0", padding: "0 9px" }}>{fullMenu.Count}</span>
                        </div>
                    )}

                    {visibleMenu.map((item, index) => {
                        const hasSelectedItem = linkedEntityId != null && linkedEntityId !== "";
                        const selected = hasSelectedItem
                            ? (item.EntityId == linkedEntityId)
                            : (item.IsGroupHeader && item.EntityType == linkedEntityType && (item.EntityId == null || item.EntityId == ""));
                        return (
                            <div key={index}>
                                {item.IsGroupHeader && <hr style={{ borderColor: "#f0f0f0" }} />}
                                <div
                                    className="menu-item-row"
                                    style={{ cursor: "pointer", display: "flex", padding: "6px", color: selected ? "#0052cc" : "#203864", backgroundColor: selected ? "#f1f1f1" : "transparent", ...(item.IsGroupHeader ? { height: "50px", alignItems: "center" } : null) }}
                                    onClick={() => onSelect(item.EntityType, item.EntityId, item.Name)}
                                >
                                    <div style={{ flex: 1, ...(item.IsGroupHeader ? { fontWeight: "bold" } : { marginLeft: "10px" }) }}>
                                        {item.IsGroupHeader && <EntityTypeIcon entityType={item.EntityType} />}
                                        {item.Name}
                                        {item.HasChildren && <i style={{ marginLeft: "10px", color: "#aaa" }} className="fas fa-chevron-right"></i>}
                                    </div>
                                    <span style={{ fontSize: "9pt", borderRadius: "15px", backgroundColor: "#f0f0f0", padding: "0 9px" }}>{item.ItemCount}</span>
                                </div>
                                {!hideAllTasksNav && isAllTasksMenuItem(item) && (
                                    <div style={{ height: "50px", display: "flex", alignItems: "center" }}><b>View Tasks By:</b></div>
                                )}
                            </div>
                        );
                    })}
                </>
            )}
        </div>
    );
};

export default TaskMenu;
